@if (legalText) {
  <div
    [id]="id"
    [innerHTML]="legalText"
    [ngClass]="{ 'end-note': isEndNote }"></div>
}
